const optionComponentType = {
  input: 'input',
  inputNumber: 'inputNumber',
  password: 'password',
  switch: 'switch',
  radio: 'radio',
  checkbox: 'checkbox',
  time: 'time',
  date: 'date',
  treeSelect: 'treeSelect',
  upload: 'upload',
  tree: 'tree',
  select: 'select'
}
export default optionComponentType